import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getCities } from "../../service/Locations/locationsService";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface City {
  label: string;
  value: string;
}

interface CitySlice {
  cities: any;
  loading: boolean;
  error: string | null;
  selectedCityOptions:any;
  selectedCity:string;
}

const initialState: CitySlice = {
  cities: {} as Record<string, string[]>,
  loading: false,
  error: null,
  selectedCityOptions:[],
  selectedCity:""
};

// Async thunk to fetch cities by state
export const fetchCities = createAsyncThunk
("cities/fetchCities",async (stateName:string, { getState }:any) => {
  //Here,Check to see if the cities are already fetched
    if (getState()?.cities.cities[stateName]) {
      return { state: stateName, cities: getState()?.cities.cities[stateName] };
    }
    const response = await getCities(stateName.toUpperCase());
    return { state: stateName, cities: response.data.data };
  }
);

const citySlice = createSlice({
  name: "cities",
  initialState,
  reducers: {
    setSelectedCity:(state,action:PayloadAction<string>)=>{
      state.selectedCity = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCities.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCities.fulfilled, (state, action) => {
        state.loading = false;
        state.cities[action.payload.state] = action.payload.cities;
      })
      .addCase(fetchCities.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch cities";
      });
  },
});
export const {setSelectedCity} = citySlice.actions;
export default citySlice.reducer;
